module.exports = __webpack_public_path__ + "static/media/rideForeground.35b566b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Ride/rideForeground.svg
// module id = 919
// module chunks = 0